import { Container } from "./styles";

const BtnPrimary = ({ ...rest }) => <Container {...rest} />;

export default BtnPrimary;
